import { normalizeTag } from './notes.js';
import { parseListText } from './lists.js';

// Quick-add grammar for a task typed on one line. Only what a thumb can type without a form:
//   "Hang the door ~45m"    → estimatedMinutes 45
//   "Hang the door ~1h30"   → 90
//   "Hang the door $120"    → moneyEarned 120
//   "Hang the door !"       → priority high ("!!" critical)
//   "Hang the door #trim"   → tags ['trim'] (a # followed by a letter; "#2 screws" stays in the title)
//   "Groceries :: milk, eggs x12, wraps"  → list { items: milk, eggs (qty 12), wraps } (shared/lists.js)
//   "Groceries\n- milk\n- eggs"           → the same: lines starting "- " after the title are list items
// The list comes off first, so a "#" or "$" inside an item stays in the item. `list` is only there when there is one.
// Anything unrecognised stays in the title. Pure.
export function parseQuickTitle(input) {
  let title = String(input || '').trim();
  let listItems = [];
  if (title.includes('\n')) {
    const [first, ...rest] = title.split('\n');
    const keep = [first];
    for (const line of rest) {
      if (/^\s*[-*•]\s+\S/.test(line)) listItems.push(...parseListText(line.trim()));
      else if (line.trim()) keep.push(line);
    }
    title = keep.join('\n').trim();
  }
  const sep = title.search(/\s::(\s|$)/);
  if (sep >= 0) {
    listItems = [...parseListText(title.slice(sep).replace(/^\s::/, '')), ...listItems];
    title = title.slice(0, sep).trim();
  }
  const out = { title, estimatedMinutes: null, moneyEarned: null, priority: null, tags: [] };
  if (listItems.length) out.list = { items: listItems };
  if (!title) return out;
  const est = title.match(/(?:^|\s)~\s*(\d+(?:\.\d+)?)\s*(h|hr|hrs|hour|hours|m|min|mins)?(?:\s*(\d{1,2})\s*m?)?(?=\s|$)/i);
  if (est) {
    const n = parseFloat(est[1]);
    const unit = (est[2] || 'm').toLowerCase();
    let mins = unit.startsWith('h') ? Math.round(n * 60) : Math.round(n);
    if (unit.startsWith('h') && est[3]) mins += parseInt(est[3], 10);
    if (mins > 0) out.estimatedMinutes = mins;
    title = (title.slice(0, est.index) + ' ' + title.slice(est.index + est[0].length)).trim();
  }
  const money = title.match(/(?:^|\s)\$(\d+(?:\.\d+)?)(?=\s|$)/);
  if (money) {
    out.moneyEarned = parseFloat(money[1]);
    title = (title.slice(0, money.index) + ' ' + title.slice(money.index + money[0].length)).trim();
  }
  title = title.replace(/(^|\s)#([a-z][\w-]*)(?=\s|$)/gi, (m, pre, t) => {
    const n = normalizeTag(t);
    if (n && !out.tags.includes(n)) out.tags.push(n);
    return pre;
  }).trim();
  const bang = title.match(/\s*(!{1,2})$/);
  if (bang) {
    out.priority = bang[1].length === 2 ? 'critical' : 'high';
    title = title.slice(0, bang.index).trim();
  }
  out.title = title.replace(/\s{2,}/g, ' ').trim();
  return out;
}
